// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"585":"3ed6de4631b4d719","888":"168554cadde88509"}[chunkId] + ".css";
};